declare global {
  interface Window {
    UW_CONFIG: { [k: string]: string };
  }
}

function getConfig(key: string) {
  // This variable is populated by public/config.js, which is updated at container runtime by docker/start-container.sh.
  const injectedConfig = window.UW_CONFIG?.[key];

  if (injectedConfig === undefined) {
    console.error('Missing runtime config var', key);
  }

  return injectedConfig;
}

export const API_ENDPOINT = `${getConfig('API_ORIGIN')}${getConfig('API_ENDPOINT')}`;
export const SNOWPLOW_ENDPOINT = getConfig('SNOWPLOW_ENDPOINT');
export const TRACKER_NAME = getConfig('TRACKER_NAME');
export const JTC_URL = getConfig('JTC_URL');
export const ENVIRONMENT = getConfig('ENVIRONMENT');
